module.exports = __webpack_public_path__ + "img/klarna.62a00559.svg";